import { addDays, differenceInCalendarDays, startOfWeek } from 'date-fns';
export function getOutsideStartDays(month, options) {
    var days = [];
    var firstDayOfWeek = startOfWeek(month, options);
    var startDiff = differenceInCalendarDays(month, firstDayOfWeek);
    for (var i = 0; i < startDiff; i++) {
        var newDay = addDays(firstDayOfWeek, i);
        days.push(newDay);
    }
    return days;
}
//# sourceMappingURL=getOutsideStartDays.js.map